import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './../user.css'

// Utils
import { removeLocalStorage, saveLocalStorage } from '../../../utils/localStorage/localStorage';
import { login_msg } from '../../../utils/msg/msg';
import { validateEmail, validatePassword } from '../../../utils/validation/validation';
import { swalErrorAlert } from '../../../utils/swal/swal';

// Store
import { useUserStore } from '../../../store/userStore';
import { useSocketStore } from '../../../store/socketStore';

// Api
import { loginApi } from '../../../api/user';


const Login = () => {
    /* zustand */
    const { userInfo, loginAction } = useUserStore(state => state)
    const { connectSocket } = useSocketStore(state => state)

    /* useState */
    const [idInput, setIdInput] = useState(localStorage.getItem('saveId') ? localStorage.getItem('saveId') : '')
    const [checkboxSaveId, setCheckboxSaveId] = useState(localStorage.getItem('saveId') ? true : false)
    const [errorMsg, setErrorMsg] = useState('')

    /* navigation & location */
    const navigate = useNavigate();
    const location = useLocation();

    /* UseEffect */
    useEffect(() => {
        if (userInfo) navigate('/')
    }, [userInfo])

    /* Methods */
    const onSubmitLoginForm = async (e) => {
        e.preventDefault();

        const passwordElement = e.target.userPassword
        const passwordValue = passwordElement.value.trim()

        // 유효성검사
        if (idInput.trim() === '' || !validateEmail(idInput)) {
            setErrorMsg(login_msg.emailError)
            return
        }
        if (passwordValue.trim() === '' || !validatePassword(passwordValue)) {
            setErrorMsg(login_msg.passwordError)
            return
        }

        // 아이디 저장
        checkboxSaveId ? saveLocalStorage('saveId', idInput) : removeLocalStorage('saveId')

        // API 요청
        try {
            let requestData = { email: idInput, password: passwordValue }
            const response = await loginApi(requestData)

            let userInfo = response?.data?.resData?.userInfo
            connectSocket(userInfo.user_id); // 소켓연결
            loginAction(userInfo) // 로그인 정보 저장

            const from = location.state?.from?.pathname && !location.state?.from?.pathname.includes('/login')
                ? location?.state?.from?.pathname
                : '/'

            navigate(from)
            return

        } catch (error) {
            if (error.status === 400) {
                let msg = error.response.data.message
                setErrorMsg(msg)
                return
            }
            else if (error.status === 500) {
                swalErrorAlert("로그인 실패", "로그인 처리 도중 에러가 발생했습니다.<br> 에러가 반복되면 관리자에게 문의해 주세요.", '', '')
                return
            }
            else return
        }
    }

    return (
        <div className='login'>
            <div className="form-signin w-100 m-auto text-center">
                <form onSubmit={onSubmitLoginForm}>
                    <div className='mb-5'>
                        <h2 className="h2 mb-3 fw-normal">로그인</h2>
                        <h5 className="h5 mb-3 fw-normal">HY교육에 오신걸 환영합니다</h5>
                    </div>

                    <div className="form-floating">
                        <input type="email" name='userEmail' className="form-control" id="floatingInput" value={idInput} onChange={e => setIdInput(e.target.value)} placeholder="아이디를 입력해주세요" />
                        <label htmlFor="floatingInput">아이디(이메일)</label>
                    </div>
                    <div className="form-floating">
                        <input type="password" name='userPassword' className="form-control" id="floatingPassword" placeholder="비밀번호를 입력해주세요" autoComplete='' />
                        <label htmlFor="floatingPassword">비밀번호</label>
                    </div>

                    {/* 에러메시지 */}
                    {errorMsg && <p className='small text-danger'>{errorMsg}</p>}

                    <div className="form-check text-start my-3">
                        <input className="form-check-input" type="checkbox" name='idCheck' defaultValue="remember-me" id="flexCheckDefault" checked={checkboxSaveId} onChange={e => setCheckboxSaveId(e.target.checked)} />
                        <label className="form-check-label" htmlFor="flexCheckDefault" style={{ verticalAlign: "-webkit-baseline-middle" }}>
                            아이디 저장
                        </label>
                    </div>
                    <button className="btn btn-primary w-100 py-2" type="submit">로그인</button>
                </form>
                <ul className='mt-4'>
                    {/* <ul className='mt-5'> */}
                    {/* <li className='mb-2'><Link to={'/findid'} className='text-secondary'>아이디/비밀번호 찾기</Link></li> */}
                    <li className='mb-2'><Link to={'/signup'} className='text-secondary'>회원가입</Link></li>
                </ul>
            </div>
        </div>
    )
}

export default Login